<script setup lang="ts">
export type TooltipVariant = "white" | "black";
export type TooltipPosition = "left" | "top" | "right" | "bottom";

interface Props {
  variant: TooltipVariant;
  position: TooltipPosition;
}

defineProps<Props>();
</script>

<template>
  <div
    class="arrow absolute rotate-45 w-3 h-3 border rounded-sm"
    :class="{
      '-right-[6px] top-0 bottom-0 my-auto': position === 'left',
      '-left-[6px] top-0 bottom-0 my-auto': position === 'right',
      '-bottom-[6px] left-0 right-0 mx-auto': position === 'top',
      '-top-[6px] left-0 right-0 mx-auto': position === 'bottom',
      'bg-white border-neutral300': variant === 'white',
      'bg-black  border-transparent': variant === 'black',
    }"
  />
  <div
    class="arrow-fixer absolute"
    :class="{
      'right-0 top-0 bottom-0 my-auto w-2 h-4': position === 'left',
      'left-0 top-0 bottom-0 my-auto w-2 h-4': position === 'right',
      'bottom-0 left-0 right-0 mx-auto w-4 h-2': position === 'top',
      'top-0 left-0 right-0 mx-auto w-4 h-2': position === 'bottom',
      'bg-white': variant === 'white',
      'bg-black': variant === 'black',
    }"
  />
</template>
